import React from 'react';
import styles from './alo.module.scss';
import Header from '../../components/header/Header';
import Title from '../../components/title/Title';
import TopBanner from '../../components/topBanner/TopBanner';
import Mission from '../../components/mission/Mission';
import SingleDescriptionBanner from '../../components/singleDescriptionBanner/singleDescriptionBanner';
import Gallery from '../../components/gallery/Gallery';
import Footer from '../../components/footer/Footer';

const Alo = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Title title="Alo" subtitle="BRAND IDENTITY (DIGITAL MEDIA, PRINT)" />
      <TopBanner
        heroImg="/images/alo_hero.svg"
        mainText="Music & Entertainment"
        subText="For ALO, DreamLabs partnered with Celeste Ojatula to translate the emotional depth of her debut EP into a cohesive live and visual experience. The project centred on capturing the warmth, soul, and timeless quality of Celeste’s sound—building a world that felt intimate yet elevated, and resonated both on stage and beyond it."
        imgOne="/images/alo_cover.svg"
        imgTwo="/images/alo_track.svg"
        pageName="alo"
      />
      <Mission text="Creative direction for Alo - photography, video direction, and event design." />
      <SingleDescriptionBanner
        heroImg="/images/alo_ad.svg"
        subText="From creative direction to execution, we handled the full visual and experiential scope of the project, including design, photography, video direction, and event design for the sold-out Alo live concert. Every element was crafted to feel intentional and immersive, ensuring the live performance, visuals, and atmosphere worked together to tell one clear, unified story."
        imgOne="/images/image.svg"
        imgTwo="/images/image_80.svg"
        pageName="alo"
      />
      <Mission text="Creative direction for Alo - photography, video direction, and event design." />
      <Gallery
        topImgOne="/images/alo_gallthree.svg"
        topImgTwo="/images/alogalltwo.svg"
        bottomImg="/images/alo_gallOne.svg"
        pageName="alo"
      />
      <div className={styles.alo_frame}>
        <img src="/images/alo_framed.svg" alt="alo_framed" />
      </div>
      <Footer />
    </div>
  );
};

export default Alo;
